import React from 'react';
import Button from '../../../components/ui/Button';

const LoginFooter = ({ className = '' }) => {
  const handleForgotPassword = () => {
    // Mock forgot password functionality
    alert('Password reset link would be sent to your email address');
  };

  const handleCreateAccount = () => {
    window.location.href = '/register';
  };

  return (
    <div className={`space-y-4 ${className}`}>
      {/* Forgot Password */}
      <div className="text-center">
        <Button
          variant="ghost"
          onClick={handleForgotPassword}
          className="text-sm text-primary hover:text-primary/80"
        >
          Forgot your password?
        </Button>
      </div>

      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-2 text-muted-foreground">New to Cogito?</span>
        </div>
      </div>
      {/* Create Account */}
      <div className="text-center">
        <Button
          variant="outline"
          onClick={handleCreateAccount}
          fullWidth
          className="py-3"
        >
          Create Your Account
        </Button>
      </div>
      {/* Footer Links */}
      <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground pt-4">
        <button className="hover:text-foreground transition-colors">Privacy Policy</button>
        <span>•</span>
        <button className="hover:text-foreground transition-colors">Terms of Service</button>
        <span>•</span>
        <button className="hover:text-foreground transition-colors">Help Center</button>
      </div>
      <div className="text-center text-xs text-muted-foreground pt-2">
        © {new Date()?.getFullYear()} Cogito. All rights reserved.
      </div>
    </div>
  );
};

export default LoginFooter;